import { AxiosResponse } from 'axios'
import {
    Resort,
    HeatmapDefinition as StoreHeatmapDefinition
} from 'store/ducks'
import api from './baseApi'

export const getResortList = async () => {
  const response: AxiosResponse<Resort[]> = await api.get('resort')
  return response.data
}

export const getResort = async (id: string | undefined) => {
  const response: AxiosResponse<Resort> = await api.get(`resort/${id}`)
  return response.data
}

// New heatmap management (API-backed)
export const listResortHeatmaps = async (): Promise<
  StoreHeatmapDefinition[]
> => {
  const response: AxiosResponse<StoreHeatmapDefinition[]> =
    await api.get(`resort/heatmaps`)
  return response.data
}

export const setDefaultResortHeatmap = async (
  heatmapId: string
): Promise<StoreHeatmapDefinition[]> => {
  const response: AxiosResponse<{ heatmaps: StoreHeatmapDefinition[] }> =
    await api.patch(`resort/heatmaps/${heatmapId}/default`)
  return response.data.heatmaps
}

export const renameResortHeatmap = async (
  heatmapId: string,
  name: string
): Promise<StoreHeatmapDefinition[]> => {
  const response: AxiosResponse<{ heatmaps: StoreHeatmapDefinition[] }> =
    await api.patch(`resort/heatmaps/${heatmapId}`, { name })
  return response.data.heatmaps
}

export const deleteResortHeatmap = async (
  heatmapId: string
): Promise<StoreHeatmapDefinition[]> => {
  const response: AxiosResponse<{ heatmaps: StoreHeatmapDefinition[] }> =
    await api.delete(`resort/heatmaps/${heatmapId}`)
  return response.data.heatmaps
}

export const createResortHeatmap = async (body: {
  name: string
  season: string
  fileName: string
}): Promise<{ id: string; season: string; path: string; putUrl: string }> => {
  const response: AxiosResponse<{
    id: string
    season: string
    path: string
    putUrl: string
  }> = await api.post(`resort/heatmaps`, body)
  return response.data
}
